import PopupTemplate from "@arcgis/core/PopupTemplate";
import FieldInfo  from "@arcgis/core/popup/FieldInfo.js";
import ActionButton from "@arcgis/core/support/actions/ActionButton.js";
import { TranslateService } from '@ngx-translate/core';

const imagem = "";
console.log("IMAGEMENORA", imagem);

// Function to create the popup template with translation support
export function createHacrazotPopupTemplate(translate: TranslateService): PopupTemplate {
  const websiteatarmenora = new ActionButton({
    title: translate.instant('iaa.map.popup.hachraza.websitePage'),
    id: "atarMVP",
  });

  const arcadeExpressionInfos = [
    {
      name: "combinedPublication",
      title: translate.instant('iaa.map.popup.hachraza.publicationBulletin'),
      expression: "return  ' מספר הפרסום:' + $feature.ATA_LAST_PIR + ', עמוד בילקוט פרסומים:' + $feature.ATA_PIR_AMUD;"
    },
  ];

  const ATA_SHEM: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.siteName') + ": ",
    fieldName: "ATA_SHEM",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const ATA_STATUS_DESC: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.siteStatus') + ": ",
    fieldName: "ATA_STATUS_DESC",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const SUG_ATAR_DESC: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.siteType') + ": ",
    fieldName: "SUG_ATAR_DESC",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const MEHOZ_NAME: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.districtName') + ": ",
    fieldName: "MEHOZ_NAME",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const ATA_DATE_STATUS: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.statusDate') + ": ",
    fieldName: "ATA_DATE_STATUS",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const PERS_DO: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.employeeNumber') + ": ",
    fieldName: "PERS_DO",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const PERS_NAME: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.employeeName') + ": ",
    fieldName: "PERS_NAME",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const combinedPublication: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.publicationBulletin') + ": ",
    fieldName: "expression/combinedPublication",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const ATAR_HEB_DESC: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.siteDescription') + ": ",
    fieldName: "ATAR_HEB_DESC",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const ATAR_ENG_DESC: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.siteDescriptionEnglish') + ": ",
    fieldName: "ATAR_ENG_DESC",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  const ATA_NOT_OK: FieldInfo = new FieldInfo({
    label: translate.instant('iaa.map.popup.hachraza.notes') + ": ",
    fieldName: "ATA_NOT_OK",
    visible: true,
    format: {
      dateFormat: "short-date",
      digitSeparator: false,
      places: 0
    },
    isEditable: false,
    statisticType: "count",
    stringFieldOption: "text-box",
    tooltip: "",
  });

  return new PopupTemplate({
    title: translate.instant('iaa.map.popup.hachraza.title'),
    actions: [websiteatarmenora],
    content: [
      {
        type: "fields",
        fieldInfos: [ATA_SHEM, ATA_STATUS_DESC, SUG_ATAR_DESC, MEHOZ_NAME, ATA_DATE_STATUS, PERS_DO, combinedPublication, ATAR_HEB_DESC, ATAR_ENG_DESC, ATA_NOT_OK]
      }
    ],
    expressionInfos: arcadeExpressionInfos
  });
}

// Legacy export for backward compatibility - will be deprecated
export const peilutIaaHacrazotPopupTemplate: PopupTemplate = new PopupTemplate({
  title: "אתר ארכיאולוגי {ATA_SHEM} , {ATAR_NUMBER}, {XOID}",
  actions: [new ActionButton({
    title: "דף אתר במאגר הלאומי",
    id: "atarMVP",
  })],
  content: [
    {
      type: "fields",
      fieldInfos: [
        new FieldInfo({
          label: "שם האתר: ",
          fieldName: "ATA_SHEM",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "סטטוס אתר: ",
          fieldName: "ATA_STATUS_DESC",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "סוג אתר: ",
          fieldName: "SUG_ATAR_DESC",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "שם מחוז: ",
          fieldName: "MEHOZ_NAME",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "תאריך הסטטוס: ",
          fieldName: "ATA_DATE_STATUS",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "מספר עובד: ",
          fieldName: "PERS_DO",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "שם עובד: ",
          fieldName: "PERS_NAME",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "ילקוט פרסומים: ",
          fieldName: "expression/combinedPublication",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "תאור ההכרזה: ",
          fieldName: "ATAR_HEB_DESC",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "תאור ההכרזה באנגלית: ",
          fieldName: "ATAR_ENG_DESC",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        }),
        new FieldInfo({
          label: "הערות: ",
          fieldName: "ATA_NOT_OK",
          visible: true,
          format: { dateFormat: "short-date", digitSeparator: false, places: 0 },
          isEditable: false,
          statisticType: "count",
          stringFieldOption: "text-box",
          tooltip: "",
        })
      ]
    }
  ],
  expressionInfos: [
    {
      name: "combinedPublication",
      title: "ילקוט פרסומים",
      expression: "return  ' מספר הפרסום:' + $feature.ATA_LAST_PIR + ', עמוד בילקוט פרסומים:' + $feature.ATA_PIR_AMUD;"
    }
  ]
});